import React, { useState, useCallback, useMemo, useEffect } from "react";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import * as Yup from "yup";
import { Formik, useFormik } from "formik";
import Flatpickr from "react-flatpickr";
import {
  listOfAssignProjects,
  addProject,
  addTasksheet,
  editProject,
  editTaskSheetHR,
  listOFTaskSheet,
  listOfProject,
  listOfTimesheet,
  viewTasksheet,
  listOfTasks,
} from "../../api/tasksheetApi";
import { getId, getRole } from "../../utils/helpers/custom";
import { checkStatusCodeSuccess, CommonLabel, dateFormat, dateFormatChange, errorHandler, Roles } from "../../utils/helpers/common";
import { ResponseStatusEnum, TimeSheetDuration } from "../../utils/helpers/enums";
import TableContainer from "../../components/common/tableContainer";
import Loader from "../../components/common/loader";
import { InputPlaceHolder, SelectPlaceHolder, validationMessages } from "../../utils/helpers/validationMasseges";
import { listOfData } from "../../api/commonApi";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import NoResultsMessage from "../../components/noResultMessage";
import { TIME_ZERO } from "../../utils/helpers/enums";
import { TaskLabel } from "../../common/constant/Task";
import { BaseSelect, MultiSelect } from "../../components/BaseComponents/BaseSelect";
import BaseInput from "../../components/BaseComponents/BaseInput";
import BaseButton from "../../components/BaseComponents/BaseButton";
import BaseModal from "../../components/BaseComponents/BaseModal";

const Status = ({ status }) => {
  switch (status) {
    case "Completed":
      return (
        <span className="badge badge-soft-success text-uppercase">
          {status}
        </span>
      );
    case "Rejected":
      return (
        <span className="badge badge-soft-danger text-uppercase">{status}</span>
      );
    case "Approved":
      return (
        <span className="badge badge-soft-success text-uppercase">
          {status}
        </span>
      );
    default:
      return (
        <span className="badge badge-soft-warning text-uppercase">
          {status}
        </span>
      );
  }
};

const TimeSheet = () => {
  const id = getId();
  const role = getRole();

  const [selectedTask, setSelectedTask] = useState(null);
  const [todo, setTodo] = useState(null);
  const [modalTodo, setModalTodo] = useState(false);
  const [modalProjectName, setModalProjectName] = useState(false);
  const [modalTaskSheet, setModalTaskSheet] = useState(false);
  const [tasksheetInnerData, setTasksheetInnerData] = useState([]);
  const [tableLoader, setTableLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [btnLoader, setBtnLoader] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [selectedMulti, setSelectedMulti] = useState([]);
  const [selectedMultiDeveloper, setSelectedMultiDeveloper] = useState([]);
  const [listOfDataState, setListOfDataState] = useState([]);
  const [techListState, setTechListState] = useState([]);
  const [selectedTechListState, setSelectedTechListState] = useState();
  const [listOfProjectState, setListOfProjectState] = useState([]);
  const [listOfTasksheetData, setListOfTaskSheetData] = useState([]);
  const [listFilteredTasksheetData, setListFilteredTasksheetData] = useState([]);
  const [listOfTimeSheet, setListOfTimeSheet] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [isProjectEdit, setIsProjectEdit] = useState(false);
  const [editTaskCellData, setEditTaskCellData] = useState();
  const [editProjectData, setEditProjectData] = useState();
  const [listOfAssignProject, setListOfAssignProject] = useState(null);
  const [listOfTask, setListOfTask] = useState();

  const fetchData = () => {
    setLoading(true);
    viewTasksheet(id)
      .then((response) => {
        setTasksheetInnerData(response?.data?.data[0]?.taskSheet);
      })
      .catch((err) => err)
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setTableLoader(true);
    fetchData();
    listOfTimesheet({
      userId: id,
    })
      .then((res) => {
        setListOfTimeSheet(res?.data?.data?.listOfTaskSheet);
      })
      .catch((err)=> setListOfTimeSheet([]))
      .finally(() => setTableLoader(false));
  }, []);

  useEffect(() => {
    if (role === Roles.HR) {
      setTableLoader(true);
      listOfProject({
        condition: {
          addedBy: id,
        },
      })
        .then((response) => {
          setListOfProjectState(response?.data?.data);
        })
        .catch((err) => {
          setLoading(false);
          return err;
        })
        .finally(() => {
          setTableLoader(false);
        });
    }
    listOfAssignProjects()
      .then((res) => setListOfAssignProject(res?.data?.data))
      .catch((err) => setLoading(false));
  }, []);

  useEffect(() => {
    setTableLoader(true);
    listOFTaskSheet({
      userId: id,
    })
      .then((res) => {
        setListOfTaskSheetData(res?.data?.data?.listOfTaskSheet);
      })
      .catch((err) => {
        setListOfTaskSheetData([]);
        return err;
      })
      .finally(() => {
        setTableLoader(false);
      });
      fetchProjectData();
  }, []);

  function handleMulti(selectedMulti) {
    setSelectedMulti(selectedMulti);
  }

  function handleMultiDevelop(selectedMultiDeveloper) {
    setSelectedMultiDeveloper(selectedMultiDeveloper);
  }

  const toggle = useCallback(() => {
    newAddTasksheet.resetForm();
    if (modalTodo) {
      setModalTodo(false);
      newAddTasksheet.resetForm();
      setModalTodo(null);
    } else {
      newAddTasksheet.resetForm();
      setModalTodo(true);
    }
  }, [modalTodo]);

  function fetchProjectData(){
    listOfData({
      modelName: "authUserModel",
      condition: {
        isDeleted: false,
      },
      selectionCriteria: ["id", "firstName", "lastName"],
    }).then((res) => {
      setListOfDataState(res?.data?.map((res) => ({
        value: res?.id,
        label: `${res?.firstName} ${res?.lastName}`,
      })));
    });
    listOfData({
      modelName: "technologyModel",
      selectionCriteria: ["id", "techName"],
    })
      .then((res) => {
        setTechListState(res?.data?.map((res) => ({
          value: res?.id,
          label: res?.techName,
        })));
      })
      .catch((err) => {
        setLoading(false);
        return err;
      })
      .finally(() => {
        setLoading(false);
      });
  }


  //Add Project Details from HR side
  const addProjectName = () => {
    fetchProjectData()
    setSelectedMultiDeveloper("");
    setSelectedTechListState("");
    setIsProjectEdit(false);
    setEditProjectData("");
    setTodo("");
    setModalProjectName(!modalProjectName);
    setTodo([]);
    projectToggle();
  };

  const projectToggle = useCallback(() => {
    if (modalProjectName) {
      setSelectedMultiDeveloper("");
      setModalProjectName(false);
      addProjectValidation.resetForm();
      setTodo(null);
    } else {
      setModalProjectName(true);
    }
  }, [modalProjectName]);

  const TaskSheetToggle = useCallback(() => {
    if (modalTaskSheet) {
      setModalTaskSheet(false);
      validation.resetForm();
      setTodo(null);
    } else {
      setModalTaskSheet(true);
    }
  }, [modalTaskSheet]);

  const QueryColumns = useMemo(() => [
    {
      Header: CommonLabel.SrNo,
      filterable: false,
      Cell: ({ row }) => row?.index + 1,
    },
    {
      Header: TaskLabel.ProjectName,
      accessor: "projectTask",
      filterable: false,
    },
    {
      Header: TaskLabel.TaskName,
      accessor: "taskSheet.taskName",
      filterable: false,
    },
    {
      Header: TaskLabel.TaskDetail,
      accessor: "detailsOfTask",
      filterable: false,
    },
    {
      Header: TaskLabel.TaskStatus,
      accessor: "taskStatus",
      filterable: false,
      Cell: (cell) => {
        return <Status status={cell.value} />;
      },
    },
    {
      Header: TaskLabel.TakenTime,
      accessor: "takenTime",
      Cell: (cell) => {
        return (
          <div>
            {`${cell.row.original.takenHours}:${cell.row.original.takenMinutes}:00`}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: TaskLabel.Date,
      accessor: "date",
      filterable: false,
      Cell: (items) => {
        return <div>{dateFormat(items.row.original.date)}</div>;
      },
    },
    {
      Header: TaskLabel.ReviewStatus,
      accessor: "reviewStatus",
      filterable: false,
      Cell: (cell) => {
        return <Status status={cell.value} />;
      },
    },
    {
      Header: TaskLabel.Reason,
      accessor: "reason",
      filterable: false,
      Cell: (cell) => {
        return (
          <div>
            {cell.row.original.reason === null ? "-" : cell.row.original.reason}
          </div>
        );
      },
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            {cellProps?.row?.original?.reviewStatus !== "Approved" ? (
              <div className="hstack gap-2">
                <ReactTooltip
                  place="bottom"
                  variant="info"
                  content="Edit Timesheet"
                  anchorId={`editAction-${cellProps.row.index}`}
                />
                <Link
                  to={`/timesheet/edit-timesheet/${cellProps?.row?.original?.id}`}
                  className="btn btn-sm btn-soft-info edit-list"
                  id={`editAction-${cellProps.row.index}`}>
                  <i className="ri-pencil-fill align-bottom" />
                </Link>
              </div>
            ) : (
              "-"
            )}
          </div>
        );
      },
    },
  ]);

  const columns = useMemo(() => [
    {
      Header: CommonLabel.SrNo,
      Cell: ({ row }) => row?.index + 1,
    },
    {
      Header: TaskLabel.TaskName,
      accessor: "taskSheet.taskName",
      filterable: false,
    },
    {
      Header: TaskLabel.TaskDetail,
      accessor: "detailsOfTask",
      filterable: false,
    },
    {
      Header: TaskLabel.TakenTime,
      accessor: "takenTime",
      Cell: (cell) => {
        return (
          <div>
            {`${cell.row.original.takenHours}:${cell.row.original.takenMinutes}:00`}
          </div>
        );
      },
      filterable: false,
    },
    {
      Header: TaskLabel.TaskStatus,
      accessor: "taskStatus",
      filterable: false,
    },
    {
      Header: TaskLabel.Date,
      Cell: (items) => {
        return <div>{dateFormat(items.row.original.date)}</div>;
      },
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <Link
                to={`/timesheet/edit-timesheet/${cellProps?.row?.original?.id}`}
                id={`edit-${cellProps.row.index}`}
              >
                <BaseButton color="soft-info" className="btn-sm">
                  <i className="ri-pencil-fill align-bottom" />
                </BaseButton>
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.Update}
                anchorId={`edit-${cellProps.row.index}`}
              />
            </div>
          </div>
        );
      },
    },
  ]);

  const handleProjectEdit = (data) => {
    const formattedData = {
        ...data,
        assignTo: data?.ProjectAssignTo?.map((project) => project?.authUser?.id),
        technologies: techListState?.reduce((acc, option) => 
          data?.technologies?.split(",").includes(option.label) ? acc.concat(option.value) : acc, []
        )
      }
    setSelectedTechListState(data?.technologies);
    projectToggle();
    setEditProjectData(formattedData);
    setIsProjectEdit(true);
    setSelectedMultiDeveloper(
      data?.ProjectAssignTo.map((data, key) => {
        return {
          value: data?.authUser?.id,
          label: data?.authUser?.developerName,
        };
      })
    );
  };

  const projectColumns = useMemo(() => [
    {
      Header: CommonLabel.SrNo,
      Cell: ({ row }) => row?.index + 1,
    },
    {
      Header: TaskLabel.ProjectName,
      accessor: "projectName",
      filterable: false,
    },
    {
      Header: TaskLabel.TotalDeveloper,
      accessor: "assignToCount",
      filterable: false,
    },
    {
      Header: TaskLabel.Description,
      accessor: "description",
      filterable: false,
    },
    {
      Header: TaskLabel.TechnologyName,
      accessor: "technologies",
      filterable: false,
    },
    {
      Header: TaskLabel.DurationMonth,
      accessor: "duration",
      filterable: false,
    },
    {
      Header: CommonLabel.Action,
      Cell: (cellProps) => {
        return (
          <div>
            <div className="hstack gap-2">
              <Link
                className="btn btn-sm btn-soft-info edit-list"
                onClick={() => handleProjectEdit(cellProps.row.original)}
                id={`edit-${cellProps.row.index}`}
              >
                <i className="ri-pencil-fill align-bottom" />
              </Link>
              <ReactTooltip
                place="bottom"
                variant="info"
                content={CommonLabel.Update}
                anchorId={`edit-${cellProps.row.index}`}
              />
            </div>
          </div>
        );
      },
    },
  ]);

  const addProjectValidation = useFormik({
    enableReinitialize: true,
    initialValues: {
      description: editProjectData?.description || "",
      duration: Number(editProjectData?.duration) || "",
      projectName: editProjectData?.projectName || "",
      assignTo: editProjectData?.assignTo || "",
      technologies: editProjectData?.technologies || "",
    },
    validationSchema: Yup.object({
      description: Yup.string().required(validationMessages.required(TaskLabel.Description)),
      duration: Yup.string().required(validationMessages.required(TaskLabel.Duration)),
      projectName: Yup.string().required(validationMessages.required(TaskLabel.ProjectName)),
      assignTo: Yup.array().required(validationMessages.required(TaskLabel.DeveloperName)),
      technologies: Yup.array().required(validationMessages.required(TaskLabel.TechnologyName)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      setModalProjectName(false);
      const payload = {
        description: values.description,
        duration: String(values.duration),
        projectName: values.projectName,
        assignTo: values.assignTo,
        addedBy: parseInt(id),
        technologies: techListState?.reduce((acc, item) => 
          values.technologies?.includes(item.value) ? acc.concat(item.label) : acc, []
        ).join(",")
      };
      if (isProjectEdit) {
        editProject({ id: editProjectData.id, ...payload })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              addProjectValidation.resetForm();
              listOfProject({
                modelName: "projectModel",
                condition: {
                  addedBy: id,
                },
              })
                .then((response) => {
                  setLoading(true);
                  setListOfProjectState(response?.data?.data);
                })
                .catch((err) => {
                  return err;
                })
                .finally(() => {
                  setLoading(false);
                });
              setModalProjectName(false);
            }
          })
          .catch((err) => {
            errorHandler(err);
            return err;
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        addProject(payload)
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              addProjectValidation.resetForm();
              listOfProject({
                modelName: "projectModel",
                condition: {
                  addedBy: id,
                },
              })
                .then((response) => {
                  setListOfProjectState(response?.data?.data);
                })
                .catch((err) => {
                  return err;
                })
                .finally(() => {
                  setLoading(false);
                });
              setModalProjectName(false);
            } else {
              toast.error(response?.data?.message);
              setModalProjectName([]);
            }
          })
          .catch((err) => {
            return err;
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });
  
  const newAddTasksheet = useFormik({
    enableReinitialize: true,
    initialValues: {
      projectTask: editTaskCellData?.projectTask || "",
      detailsOfTask: editTaskCellData?.detailsOfTask || "",
      taskStatus: editTaskCellData?.taskStatus || "",
      takenTime: editTaskCellData?.takenTime || "",
      date: editTaskCellData?.date || "",
      taskSheetId: editTaskCellData?.taskSheetId || "",
      takenHours: editTaskCellData?.takenHours || "",
      takenMinutes: editTaskCellData?.takenMinutes || "",
      dailyStatus: editTaskCellData?.dailyStatus || "",
    },
    validationSchema: Yup.object({
      detailsOfTask: Yup.string().required(validationMessages.required(TaskLabel.TaskDetail)),
      projectTask: Yup.string().required(validationMessages.required(TaskLabel.Project)),
      taskStatus: Yup.string().required(validationMessages.required(TaskLabel.TaskStatus)),
      date: Yup.date().required(validationMessages.required(TaskLabel.Date)),
      dailyStatus: Yup.string().required(validationMessages.required(TaskLabel.DailyStatus)),
      takenMinutes: Yup.string().optional(),
      takenHours: Yup.string().required(validationMessages.required(TaskLabel.Hour)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      if (isEdit) {
        editTaskSheetHR(editTaskCellData?.id, { ...values })
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              newAddTasksheet.resetForm();
              setLoading(true);
              listOFTaskSheet({
                userId: id,
              })
                .then((response) => {
                  setLoading(true);
                  setListOfTaskSheetData(response?.data?.data?.listOfTaskSheet);
                })
                .catch((err) => {
                  setLoading(false);
                  return err;
                })
                .finally(() => {
                  setLoading(false);
                });
              setModalTodo(false);
              setModalTodo([]);
            } else {
              toast.error(response?.data?.message);
              setLoading(false);
              setModalTodo(false);
            }
          })
          .catch((err) => {
            setLoading(false);
            setModalTodo(false);
            return err;
          })
          .finally(() => {
            setLoading(false);
            setModalTodo(false);
          });
        setModalTodo(false);
        newAddTasksheet.resetForm();
      } else {
        let payload = {
          userId: id,
          projectTask: values?.projectTask,
          taskSheetId: values?.taskSheetId,
          detailsOfTask: values?.detailsOfTask,
          date: values?.date,
          takenMinutes: +values?.takenMinutes,
          takenHours: +values?.takenHours,
          taskStatus: values?.taskStatus,
          dailyStatus: values?.dailyStatus,
        };
        addTasksheet(payload)
          .then((response) => {
            if (checkStatusCodeSuccess(response?.data?.statusCode)) {
              toast.success(response?.data?.message);
              setLoading(true);
              listOFTaskSheet({
                userId: id,
              })
                .then((response) => {
                  setListOfTaskSheetData(response?.data?.data?.listOfTaskSheet);
                })
                .catch((err) => {
                  setLoading(false);
                  return err;
                })
                .finally(() => {
                  setLoading(false);
                });
              setModalTodo(false);
            } else {
              toast.error(response?.data?.message);
              setLoading(false);
              setModalTodo(false);
            }
          })
          .catch((err) => {
            setLoading(false);
            setModalTodo(false);
            return err;
          })
          .finally(() => {
            setModalTodo(false);
            setLoading(false);
          });
        setModalTodo(false);
        newAddTasksheet.resetForm();
      }
    },
  });

  useEffect(() => {
    if (newAddTasksheet?.values?.projectTask) {
      const projectName = newAddTasksheet?.values?.projectTask;
      listOfTasks({
        assignTo: parseInt(id),
        projectName,
        taskStatus: "Pending",
      })
        .then((res) => setListOfTask(res?.data?.data))
        .catch((err) => {
          setListOfTask([]);
          return err;
        });
    }
  }, [newAddTasksheet?.values?.projectTask, id]);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      nameOfTask: todo?.nameOfTask || "",
      detailsOfTask: todo?.detailsOfTask || "",
      dueDate: todo?.dueDate || "",
      takenTime: todo?.takenTime || "",
    },
    validationSchema: Yup.object({
      nameOfTask: Yup.string().required(validationMessages.required(TaskLabel.TaskStatus)),
      detailsOfTask: Yup.string().required(validationMessages.required(TaskLabel.TaskDetail)),
      dueDate: Yup.string().required(validationMessages.required(TaskLabel.StartDate)),
      takenTime: Yup.string().required(validationMessages.required(TaskLabel.TakenTime)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      addTasksheet({
        addedBy: parseInt(id, 10),
        date: values.dueDate,
        nameOfTask: values.nameOfTask,
        detailsOfTask: values.detailsOfTask,
        takenTime: values.takenTime,
        taskSheetId: values?.taskSheetId,
        status: "Pending",
      })
        .then((response) => {
          if (checkStatusCodeSuccess(response?.data?.statusCode)) {
            toast.success(response?.data?.message);
            setLoading(true);
            viewTasksheet(id)
              .then((response) => {
                setTasksheetInnerData(response?.data?.data[0].taskSheet);
              })
              .catch((err) => err)
              .finally(() => {});
          } else {
            toast.error(response?.data?.message);
          }
        })
        .catch((err) => err)
        .finally(() => {
          setLoading(false);
        });
      setModalTodo(false);
      validation.resetForm();
      toggle();
    },
  });

  const validationOfFilter = useFormik({
    enableReinitialize: true,

    initialValues: {
      date: "",
      developerName: "",
    },
    validationSchema: Yup.object({
      date: Yup.string().optional(),
      developerName: Yup.string().optional(),
    }),
    onSubmit: (value) => {
      setIsFilter(true);
      setBtnLoader(true);
      listOFTaskSheet({
        userId: id,
        ...value,
      })
        .then((res) => {
          if (checkStatusCodeSuccess(res?.data?.statusCode)) { 
            setListFilteredTasksheetData(res?.data?.data?.listOfTaskSheet);
          } else {
            setListFilteredTasksheetData([]);
          }
        })
        .catch((err) => {
          setListFilteredTasksheetData([]);
          return err;
        })
        .finally(() => {
          setBtnLoader(false);
        });
      validationOfFilter.resetForm();
    },
  });


  document.title = TaskLabel.Timesheet;

  let dataList = null;
  isFilter
    ? (dataList = listFilteredTasksheetData)
    : (dataList = listOfTimeSheet);

  let hrDataList = null;
  if (role === Roles.HR) {
    isFilter
      ? (hrDataList = listFilteredTasksheetData)
      : (hrDataList = listOfTasksheetData);
  }
  
  return (
    <React.Fragment>
      <div className="page-content">
          <Container fluid>
            <BreadCrumb title={TaskLabel.Timesheet} pageTitle="HRMS" />
            <Row className="mb-2">
              <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                <h5 className="fw-semibold mt-2">{TaskLabel.Timesheet}</h5>
              </div>
              {role === Roles.HR ? (
                <div className="col-auto order-2 order-sm-3 ms-auto">
                  <div className="hstack gap-2">
                    <BaseButton
                      color="warning"
                      type="button"
                      onClick={() => addProjectName()}>
                      <i className="ri-add-line align-bottom"></i> {TaskLabel.AddProject}
                    </BaseButton>
                    <Link to={"/timesheet/add-timesheet"}>
                      <BaseButton
                        color="primary"
                        type="button">
                        <i className="ri-add-line align-bottom"></i> {TaskLabel.Timesheet}
                      </BaseButton>
                    </Link>
                  </div>
                </div>
              ) : role === Roles.Admin ? null : (
                <div className="col-auto order-2 order-sm-3 ms-auto">
                  <div className="hstack gap-2">
                    <Link
                      to={"/timesheet/add-timesheet"}
                      className="btn btn-primary">
                      <i className="ri-add-line align-bottom"></i> {TaskLabel.Timesheet}
                    </Link>
                  </div>
                </div>
              )}
            </Row>
            <Row>
              <Card>
                <CardBody className="mt-0">
                  <Formik
                    initialValues={validationOfFilter.initialValues}
                    validationSchema={validationOfFilter.validationSchema}
                    onSubmit={validationOfFilter.handleSubmit}>
                    <Form onSubmit={validationOfFilter.handleSubmit}>
                      <Row>
                        <Col lg={6} md={6}>
                          <div className="p-2">
                            <Flatpickr
                              className="form-control"
                              id="datepicker-publish-input"
                              placeholder="Select date"
                              onBlur={validationOfFilter.handleBlur}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "d.m.y",
                                onChange: function (selectedDates) {
                                  validationOfFilter.setFieldValue(
                                    "date",
                                    dateFormatChange(selectedDates[0])
                                  );
                                },
                              }}
                            />
                          </div>
                        </Col>
                        <Col lg={6} md={6}>
                          <div className="d-flex m-2 gap-2">
                            <BaseButton
                              color="primary"
                              type="submit"
                              loader={btnLoader}>
                                {CommonLabel.Search}
                            </BaseButton>
                            <BaseButton
                              color="warning"
                              type="button"
                              onClick={()=> setIsFilter(false)}
                            >
                              {CommonLabel.Discard}
                            </BaseButton>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </Formik>
                </CardBody>
              </Card>
            </Row>
            {role === Roles.HR ? (
              <>
                <Card>
                  <CardHeader className="align-items-center d-flex">
                    <h4 className="card-title mb-0 flex-grow-1">{TaskLabel.Timesheet}</h4>
                  </CardHeader>
                  <CardBody>
                    {(hrDataList?.length || tableLoader) ? (
                      <TableContainer
                        columns={columns}
                        data={hrDataList || []}
                        isAddUserList={false}
                        isGlobalFilter={false}
                        customPageSize={5}
                        tableLoader={tableLoader}
                        divClass="table-responsive table-card mb-1"
                        tableClass="align-middle table-wrap"
                        theadClass="table-light text-muted"
                      />
                    ) : (
                      <NoResultsMessage />
                    )}
                  </CardBody>
                </Card>
                {(listOfProjectState?.length || tableLoader) && (
                  <Card>
                    <CardHeader className="align-items-center d-flex">
                      <h4 className="card-title mb-0 flex-grow-1">{TaskLabel.Project}</h4>
                    </CardHeader>
                    <CardBody>
                      {(listOfProjectState?.length || tableLoader) ? (
                        <TableContainer
                          columns={projectColumns}
                          data={listOfProjectState || []}
                          isAddUserList={false}
                          isGlobalFilter={true}
                          customPageSize={5}
                          tableLoader={tableLoader}
                          divClass="table-responsive table-card mb-1"
                          tableClass="align-middle table-wrap"
                          theadClass="table-light text-muted"
                        />
                      ) : (
                        <NoResultsMessage />
                      )}
                    </CardBody>
                  </Card>
                )}
              </>
            ) : (
              <Card>
                <CardHeader className="align-items-center d-flex">
                  <h4 className="card-title mb-0 flex-grow-1">
                    {TaskLabel.ListOfTimesheet}
                  </h4>
                </CardHeader>
                <CardBody>
                  {(dataList?.length>0 || tableLoader) ? (
                    <TableContainer
                      columns={QueryColumns}
                      data={dataList || []}
                      isAddUserList={false}
                      customPageSize={5}
                      tableLoader={tableLoader}
                      divClass="table-responsive table-card mb-1"
                      tableClass="align-middle table-wrap"
                      theadClass="table-light text-muted"
                    />
                  ) : (
                    <NoResultsMessage />
                  )}
                </CardBody>
              </Card>
            )}
          </Container>
      </div>

        <BaseModal
          open={modalProjectName}
          title={isProjectEdit ? TaskLabel.EditProject : TaskLabel.AddProject}
          closeLabel={CommonLabel.Close}
          submitLabel={isProjectEdit ? CommonLabel.Update : CommonLabel.Submit}
          closeLabelColor="ghost-success"
          submitLabelColor="primary"
          loader={loading}
          toggle={() => {
            setModalProjectName(false);
            addProjectValidation.resetForm();
          }}
          submit={() => {
            addProjectValidation.handleSubmit();
          }}
        >
          <Form
            id="creattask-form"
            onSubmit={(e) => {
              e.preventDefault();
              addProjectValidation.handleSubmit();
              return false;
            }}>
            <Row>
              <Col lg={6}>
                <div className="mb-3">
                  <BaseInput
                    name="projectName"
                    type="text"
                    placeholder={InputPlaceHolder(TaskLabel.ProjectName)}
                    label={TaskLabel.ProjectName}
                    onChange={addProjectValidation.handleChange}
                    handleBlur={addProjectValidation.handleBlur}
                    value={addProjectValidation?.values?.projectName}
                    touched={addProjectValidation.touched.projectName}
                    error={addProjectValidation.errors.projectName}
                    required={true}
                  />
                </div>
              </Col>

              <Col lg={6}>
                <div className="mb-3">
                  <BaseInput
                    name="description"
                    type="text"
                    placeholder={InputPlaceHolder(TaskLabel.ProjectDescription)}
                    label={TaskLabel.ProjectDescription}
                    onChange={addProjectValidation.handleChange}
                    handleBlur={addProjectValidation.handleBlur}
                    value={addProjectValidation?.values?.description}
                    touched={addProjectValidation.touched.description}
                    error={addProjectValidation.errors.description}
                    required={true}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <BaseSelect
                    name="duration"
                    placeholder={SelectPlaceHolder(TaskLabel.Duration)}
                    label={TaskLabel.Duration}
                    options={TimeSheetDuration}
                    value={addProjectValidation.values.duration}
                    handleChange={(field, value) => {
                      addProjectValidation.setFieldValue(field, value);
                    }}
                    handleBlur={addProjectValidation.handleBlur}
                    touched={addProjectValidation.touched.duration}
                    error={addProjectValidation.errors.duration}
                    required={true}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <MultiSelect
                    name="assignTo"
                    placeholder={SelectPlaceHolder(TaskLabel.DeveloperName)}
                    label={TaskLabel.DeveloperName}
                    options={listOfDataState}
                    value={listOfDataState?.filter((option) =>
                      addProjectValidation.values.assignTo?.includes(option?.value))
                    }
                    onChange={(selectedOption) => {
                      const selectedValues =
                      selectedOption?.length > 0
                        ? selectedOption?.map((item) => {
                            return item?.value;
                          })
                        : null;
                      addProjectValidation.setFieldValue("assignTo", selectedValues);
                    }}
                    handleBlur={addProjectValidation.handleBlur}
                    touched={addProjectValidation.touched.assignTo}
                    error={addProjectValidation.errors.assignTo}
                  required={true}
                  isMulti={true}
                  />
                </div>
              </Col>
              <Col lg={6}>
                <div className="mb-3">
                  <MultiSelect
                    name="technologies"
                    placeholder={SelectPlaceHolder(TaskLabel.TechnologyName)}
                    label={TaskLabel.TechnologyName}
                    options={techListState}
                    value={techListState?.filter((option) =>
                      addProjectValidation.values.technologies?.includes(option?.value))
                    }
                    onChange={(selectedOption) => {
                      const selectedValues =
                      selectedOption?.length > 0
                        ? selectedOption?.map((item) => {
                            return item?.value;
                          })
                        : null;
                      addProjectValidation.setFieldValue("technologies", selectedValues);
                    }}
                    handleBlur={addProjectValidation.handleBlur}
                    touched={addProjectValidation.touched.technologies}
                    error={addProjectValidation.errors.technologies}
                    required={true}
                    isMulti={true}
                  />
                </div>
              </Col>
            </Row>
          </Form>
      </BaseModal>

    </React.Fragment>
  );
};

export default TimeSheet;
